__turbopack_context__.v({
  "black": "Hero-module-scss-module__dWjK_G__black",
  "blink": "Hero-module-scss-module__dWjK_G__blink",
  "hero": "Hero-module-scss-module__dWjK_G__hero",
  "heroComponent": "Hero-module-scss-module__dWjK_G__heroComponent",
  "heroContent": "Hero-module-scss-module__dWjK_G__heroContent",
  "heroCredits": "Hero-module-scss-module__dWjK_G__heroCredits",
  "heroMedia": "Hero-module-scss-module__dWjK_G__heroMedia",
  "heroText": "Hero-module-scss-module__dWjK_G__heroText",
  "overviewButton": "Hero-module-scss-module__dWjK_G__overviewButton",
  "projectTitle": "Hero-module-scss-module__dWjK_G__projectTitle",
});
